
function findPos(obj) {
    var curleft = 0, curtop = 0;
    if (obj.offsetParent) {
        do {
            curleft += obj.offsetLeft;
            curtop += obj.offsetTop;
        } while (obj = obj.offsetParent);
        return { x: curleft, y: curtop };
    }
    return undefined;
}

function getOffset(element)
{
    if (!element.getClientRects().length)
    {
      return { top: 0, left: 0 };
    }

    let rect = element.getBoundingClientRect();
    let win = element.ownerDocument.defaultView;
    return (
    {
      top: rect.top + win.pageYOffset,
      left: rect.left + win.pageXOffset
    });   
}


function convertTime(miliseconds) {
    var totalSeconds = Math.floor(miliseconds/1000);
    var minutes = Math.floor(totalSeconds/60);
    var seconds = totalSeconds - minutes * 60;
    if (seconds < 10) {
        seconds = '0' + seconds;
    }
    return minutes + ':' + seconds;
}

function setCookie(cname, cvalue, exdays, exseconds) {
    var d = new Date();
    if (exdays) {
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
    } else if (exseconds) {
        d.setTime(d.getTime() + (exseconds*1000));
    }
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/;";
  }
  
  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length,c.length);
      }
    }
    return "";
  }


const klaviyoSubscribe = async (email, variant) => {
    const payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                  "type": "profile",
                  "attributes": {
                      "email": email,
                  }
              }
            },
            "channels": ["EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": `$shopify:::$default:::${variant}`
              }
            }
          }
        }
    }

    var requestOptions = {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "revision": "2023-09-15"
        },
        body: JSON.stringify(payload),
    };

    let resp = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=LgPrnp`,requestOptions);
    if (resp.status === 202) {
        localStorage.setItem(`klaviyo-subscribed-${variant}`, true);
        alert('Thank you for subscribing!');
    } else {
        alert('Something went wrong, please try again later.');
    }
}  

if (!window.Shopify.formatMoney) {

    window.Shopify.formatMoney = (cents, format) => {
        if (!format) {
          format = window.theme.moneyFormat;
        }
    
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || moneyFormat);
    
        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = 2;
          thousands = ',';
          decimal = '.';
    
          if (isNaN(number) || number == null) {
            return 0;
          }
    
          number = (number / 100.0).toFixed(precision);
    
          var parts = number.split('.');
          var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
          var centsAmount = parts[1] ? (decimal + parts[1]) : '';
    
          return dollarsAmount + centsAmount;
        }
    
        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
    
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
    
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;
        }
    
        return formatString.replace(placeholderRegex, value);
    }
}

document.addEventListener('DOMContentLoaded', function() {
    // check if mobile or desktop
    var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
    let maxHeight = isMobile ? 50 : 70;
    var collectionDescription = document.querySelector('.collection--description');
    if (collectionDescription) {
        // add read more class if height is greater than 3 lines
        if (collectionDescription.clientHeight > maxHeight) {
            collectionDescription.classList.add('collection--description__read-more');
        }
    
        // add event listener to read more button
        document.querySelector('.collection--description__read-more-link').addEventListener('click', function() {
            collectionDescription.classList.toggle('collection--description__read-more--open');
        });
    }

    let filterHeader = document.querySelector('nav.productgrid--utils');
    let stickyHeader = document.querySelector('.site-header--sticky');
    let featuredCollection = document.querySelector('.collection--featured');
    let filterHeaderPlaceholder = document.querySelector('.utils-placeholder');
    let isFiltered = document.querySelector('body').classList.contains('products-filtered');
    
    
    if (filterHeader) {
        let featuredCollectionOffset = getOffset(filterHeader).top;
        setInterval(() => {
            if (!filterHeader.classList.contains('productgrid--utils__fixed')) {
                featuredCollectionOffset = getOffset(filterHeader).top;
            }
            let scrollPosition = window.scrollY + (isMobile ? 0 : stickyHeader.clientHeight);
            let filterPos = featuredCollectionOffset;
            if (scrollPosition > (filterPos)) {
                filterHeader.classList.add('productgrid--utils__fixed');
                filterHeaderPlaceholder.classList.add('utils-placeholder--active');
                filterHeaderPlaceholder.style.height = filterHeader.clientHeight + 'px';
                filterHeader.style.setProperty('--top-offset-desktop', stickyHeader.clientHeight + 'px');
            } else {
                filterHeader.classList.remove('productgrid--utils__fixed');
                filterHeaderPlaceholder.classList.remove('utils-placeholder--active');
                filterHeader.style.removeProperty('--top-offset-desktop');
            }
        }, 100);
    }

    let subscribeElement = document.querySelector('.klaviyo-bis-trigger');
    if (subscribeElement) {
        let subscriptionModal = document.querySelector('.subscription-modal');

        subscribeElement.addEventListener('click', function() {
            subscriptionModal.classList.add('subscription-modal--open');
        });

        let subscriptionButton = document.querySelector('.subscription-submit');
        let subscriptionEmail = document.querySelector('.subscription-email');
        let subscriptionOverlay = document.querySelector('.subscription-modal__overlay');

        subscriptionButton.addEventListener('click', function() {
            let currentVariant = subscribeElement.dataset.variant;
            klaviyoSubscribe(subscriptionEmail.value, currentVariant);
            subscriptionModal.classList.remove('subscription-modal--open');
        });

        subscriptionOverlay.addEventListener('click', function() {
            subscriptionModal.classList.remove('subscription-modal--open');
        });
        
        window.addEventListener('shopify-variants:switch-variant', function(e) {
            let variant = e.detail.variant;
    
            let variantSubscribed = localStorage.getItem(`klaviyo-subscribed-${variant.id}`);
    
            if (!variant.available && !variantSubscribed) {
                subscribeElement.dataset.variant = variant.id;
                subscribeElement.classList.add('klaviyo-bis-trigger--active');
            } else {
                subscribeElement.classList.remove('klaviyo-bis-trigger--active');
            }
        });
    }


    let description = document.querySelector('.product-description__inner');

    if (description) {
        description.style.setProperty('--max-height', description.scrollHeight + 'px');
        let readMore = document.querySelector('.product-description__more');
        readMore.addEventListener('click', function() {
            description.classList.toggle('product-description--open');
            if (description.classList.contains('product-description--open')) {
                readMore.innerHTML = 'Read less';
            } else {
                readMore.innerHTML = 'Read more';
            }
        });
    }

    let completeLookAddToCarts = document.querySelectorAll('.upsell__product-atc');
    if (completeLookAddToCarts) {
        completeLookAddToCarts.forEach(function(element) {
            element.addEventListener('click', async () => {
                let variant = element.closest('.upsell__product').querySelector('.upsell__product-variants select').value;
                await fetch(`/cart/add.js?quantity=1&id=${variant}`).then(function(response) {
                    return response.json();
                });
                //document.dispatchEvent(new CustomEvent('shopify-variants:add-to-cart', { detail: { handle: element.dataset.handle } }));
            });
        });
    }

    let addToCart = document.querySelector('.product-form--atc-button');
    if (addToCart) {
        let options = document.querySelectorAll('.form-options.js-required');
        addToCart.addEventListener('click', function(e) {
            let checkedOptions = document.querySelectorAll('.form-options.js-required input:checked');
            if (checkedOptions.length < options.length) {
                e.preventDefault();
                e.stopPropagation();
                let optionsToWarn = document.querySelectorAll('input+.option-value-name');
                optionsToWarn.forEach(function(element) {
                    element.classList.add('option-value-name--warn');
                });
                options[0].scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
                return false;
            }
            setTimeout(() => {
                let productId = addToCart.closest('form').querySelector('[name="product-id"]').value;
                let variantId = addToCart.closest('form').querySelector('[name="id"]').value;
                //document.dispatchEvent(new CustomEvent('shopify-variants:add-to-cart', { detail: { handle: addToCart.dataset.handle, variantId, productId } }));
            }, 500);
        });
    }


    let optionValues = document.querySelectorAll('.option-value-name');
    optionValues.forEach(function(element) {
        element.addEventListener('click', function() {
            optionValues.forEach(function(element) {
                element.classList.remove('option-value-name--warn');
            });
        });
    });
});

class SaleSwitch extends HTMLElement {
    constructor() {
        super();
        this.saleSwitch = this.querySelector('.productgrid--sidebar-sale__switch');
    }

    connectedCallback() {
        if (!this.listener) {
            this.listener = true;
            setTimeout(() => {
                this.saleSwitch = this.querySelector('.productgrid--sidebar-sale__switch');
                if (!this.saleSwitch) return;
    
                this.saleSwitch.addEventListener('click', function() {
                    let switchLink = document.querySelector('.productgrid--sidebar-dropdown__sale .filter-item a');
                    switchLink.click();
                    setTimeout(() => {
                        window.scrollTo(0, 0);
                    });
                });
            });
        }
    }
}

customElements.define('sale-switch', SaleSwitch);
    
class FiltersWrapper extends HTMLElement  {
    eventListeners = [];
    sidebarDropdowns = [];
    constructor() {
        super();
        let self = this;

        window.history.pushState = new Proxy(window.history.pushState, {
            apply: function(target, thisArg, args) {
                self.disconnectedCallback();
                self.connectedCallback();
                return target.apply(thisArg, args); 
            }
        });
        document.addEventListener('shopify:section:load', this.connectedCallback);
        document.addEventListener('shopify:section:unload', this.disconnectedCallback);
    }

    connectedCallback() {
        let self = this;
        var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

        setTimeout(function() {

            this.sidebarDropdowns = document.querySelectorAll('.productgrid--sidebar-dropdown'); 
            window.addEventListener('click', function(element) {
                if (element.target.closest('.productgrid--sidebar-dropdown') === null) {
                    self.sidebarDropdowns.forEach(function(element) {
                        element.querySelector('ul').classList.remove('open');
                        element.querySelector('h3').classList.remove('open');
                    });
                }
            });

            setTimeout(function() {
                this.sidebarDropdowns.forEach(function(element) {
                    let selector = element.querySelector('h3');
                    self.eventListeners.push({
                        element: element,
                        eventListener: 'selectorClick'
                    });

                    selector.addEventListener('click', self.selectorClick.bind(self, element, selector))
                });
            }, 1000);

            let sortTrigger = document.querySelectorAll('[data-productgrid-trigger-sort-button]');
            if (sortTrigger) {
                sortTrigger.forEach(function(element) {
                    self.eventListeners.push({
                        eventListener: element.addEventListener('click', function() {
                            let parent = element.closest('.productgrid--sidebar-dropdown');
                            let sortTitle = parent.querySelector('.productgrid--sidebar-title--small');
                            let sortTitleText = parent.querySelector('.productgrid--sidebar-title--small-text');
                            let sortOptions = parent.querySelector('.productgrid--sidebar-dropdown-list');
                            sortTitle.classList.toggle('open');
                            sortOptions.classList.toggle('open');
                            sortTitleText.innerHTML = element.innerHTML;
                        }),
                        element: element
                    });
                });
            }

            const swiper = new Swiper('.swiper', {
                loop: true,
                slidesPerView: 4,
                spaceBetween: 20,
                watchOverflow: true,
                breakpoints: {
                    0: {
                        slidesPerView: 2,
                        pagination: {
                            el: '.swiper-pagination',
                            enabled: true,
                        },
                        navigation: {
                            enabled: false,
                        }
                    },
                    719: {
                        slidesPerView: 4,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                    },
                }
            });
            

            let nextButton = document.querySelector('.custom-swiper-next');
            let prevButton = document.querySelector('.custom-swiper-prev');
            let featuredProducts = document.querySelectorAll('.collection--featured .collection--featured__product');

            if (nextButton && prevButton) {
                self.eventListeners.push({
                    eventListener: nextButton.addEventListener('click', function() {
                        swiper.slideNext();
                    }),
                    element: nextButton
                });
                self.eventListeners.push({
                    eventListener: prevButton.addEventListener('click', function() {
                        swiper.slidePrev();
                    }),
                    element: prevButton
                });


                if (isMobile && featuredProducts.length <= 2) {
                    nextButton.style.display = 'none';
                    prevButton.style.display = 'none';
                } else if (featuredProducts.length <= 4) {
                    nextButton.style.display = 'none';
                    prevButton.style.display = 'none';
                }
            }


            let filterText = document.querySelector('.utils-filter .utils-filter-text');
            let popupFiltersActive = document.querySelectorAll('.productgrid--utils .productgrid--sidebar-section .filter-item--active');
            filterText.innerHTML = `Filters ${popupFiltersActive.length > 0 ? `(${popupFiltersActive.length})` : ''}`;


            window.addEventListener('filters-modal-open', function() {
                let popupFilters = document.querySelectorAll('.modal--productgrid-filters .filter-item');
            
                popupFilters.forEach(function(element) {
                    self.eventListeners.push({
                        eventListener: element.addEventListener('click', function(e) {
                            if (element.classList.contains('filter-item--disabled')) return;
                            element.closest('.filter-item').classList.toggle('filter-item--inactive');
                            element.closest('.filter-item').classList.toggle('filter-item--active');
            
                            let parentDropdown = element.closest('.productgrid--sidebar-dropdown');
                            let activeChildren = parentDropdown.querySelectorAll('.filter-item--active');
                            parentDropdown.querySelector('.productgrid--sidebar-count').innerHTML = activeChildren.length;
                            if (activeChildren.length > 0 && !parentDropdown.classList.contains('productgrid--sidebar-dropdown__active')) {
                                parentDropdown.classList.add('productgrid--sidebar-dropdown__active');
                            } else if (activeChildren.length === 0 && parentDropdown.classList.contains('productgrid--sidebar-dropdown__active')) {
                                parentDropdown.classList.remove('productgrid--sidebar-dropdown__active');
                            }
                         
                        }),
                        element: element
                    });
                });
                
                let collectionUrl = document.querySelector('.productgrid--outer').dataset.collectionUrl;
            });
            
        }, 1000);
    }

    disconnectedCallback() {
        let self = this;
        this.sidebarDropdowns = document.querySelectorAll('.productgrid--sidebar-dropdown'); 

        this.sidebarDropdowns.forEach(function(element) {
            element.replaceWith(element.cloneNode(true));
        });
        let sortTrigger = document.querySelectorAll('[data-productgrid-trigger-sort-button]');

        sortTrigger.forEach(function(element) {
            element.replaceWith(element.cloneNode(true));
        });


        let popupFilters = document.querySelectorAll('.modal--productgrid-filters .filter-item');
            
        popupFilters.forEach(function(element) {
            element.replaceWith(element.cloneNode(true));
        });
    }

    selectorClick(element, selector) {
        this.sidebarDropdowns = document.querySelectorAll('.productgrid--sidebar-dropdown'); 

        let isOpen = element.querySelector('ul').classList.contains('open');
        if (window.innerWidth > 760) {
            this.sidebarDropdowns.forEach(function(element) {
                element.querySelector('ul').classList.remove('open');
                element.querySelector('h3').classList.remove('open');
            });
        }
        if (!isOpen) {
            element.querySelector('ul').classList.add('open');
            selector.classList.add('open');
        } else {
            element.querySelector('ul').classList.remove('open');
            selector.classList.remove('open');
        }
    }
}

customElements.define('filters-wrapper', FiltersWrapper);

class StickyATC extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        if (!this.listener) {
            this.listener = true;
            
            setTimeout(() => {
                this.mainATC = document.querySelector('.product-form--atc-button');
                this.stickyATC = this.querySelector('.sticky-atc__button');
                this.klaviyoForm = document.querySelector('[class*="kl-teaser"]');
                window.addEventListener('scroll', this.scrollEvent.bind(this));
                (this.stickyATC || {}).addEventListener('click', this.addToCart.bind(this));
            });
        }
    }

    scrollEvent() {
        let atcPosition = getOffset(this.mainATC).top;
        if (!this.klaviyoForm) this.klaviyoForm = document.querySelector('[class*="kl-teaser"]');
        
        if (window.scrollY > atcPosition) {
            this.classList.add('sticky-atc--visible');
            if (!!this.klaviyoForm) this.klaviyoForm.style.display = 'none';
        } else {
            this.classList.remove('sticky-atc--visible');
            if (!!this.klaviyoForm) this.klaviyoForm.style.display = 'block';
        }
    }

    async addToCart() {
        this.mainATC.click();
    }
}

customElements.define('sticky-atc', StickyATC);

function isMobileDevice() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
};

class WishlistPopup extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        setTimeout(() => {
            if (!this.listener) {
                this.wishlistButton = this.querySelector('.wishlist-button');
                this.wishlistSizesContainer = this.querySelector('.wishlist-sizes');
                this.wishlistSizes = this.querySelectorAll('.wishlist-sizes .wishlist-sizes__size');
                this.listener = true;

                this.swymInit();

                if (this.dataset.single == 'false') {
                    if (isMobileDevice()) {
                        this.wishlistButton.addEventListener('click', this.wishlistSizesToggle.bind(this));
                    } else {
                        this.wishlistButton.addEventListener('mouseover', this.wishlistSizesOpen.bind(this));
                    }
                }

                document.addEventListener('click', function(e) {
                    if (e.target.closest('.wishlist-sizes') === null && e.target.closest('.wishlist-button') === null) {
                        this.wishlistSizesContainer.classList.remove('wishlist-sizes--open');
                    }
                }.bind(this));
                
                this.wishlistSizes.forEach(function(element) {
                }.bind(this));
            }
        });
    }

    wishlistSizesToggle() {
        if (this.wishlistSizesContainer.classList.contains('wishlist-sizes--open')) {
            this.wishlistSizesContainer.classList.remove('wishlist-sizes--open');
        } else {
            this.wishlistSizesContainer.classList.add('wishlist-sizes--open');
        }
    }

    wishlistSizesOpen() {
        this.wishlistSizesContainer.classList.add('wishlist-sizes--open');
    }

    wishlistSizeClick(element) {
        this.wishlistSizesContainer.classList.remove('wishlist-sizes--open');
    }

    fetchCallbackFn(products){
        let self = this;
        this.cart = document.querySelector('cart-wrapper');

        if (this.dataset.single == 'true') {
            self.wishlistButton = self.querySelector('.wishlist-button');
            var activeProductId = SwymPageData.empi, 
            activeVariantId = SwymPageData.epi;

            var isInWishlist = products.find(function(p){
                return p.empi == activeProductId && p.epi == activeVariantId;
            });

            if(isInWishlist){
                self.wishlistButton.classList.add('wishlist-button--added');
            }
            
            self.wishlistButton.addEventListener("click", function(e){
                if(SwymPageData){
                    SwymPageData.et = 4;	// et 4 stands for wishlist event type
                    if (self.wishlistButton.classList.contains('wishlist-button--added')) {
                        _swat.removeFromWishList(SwymPageData, function(e){
                            self.wishlistButton.classList.remove('wishlist-button--added');
                        });
                        self.cart.refreshWishlist();
                        return;
                    }

                    _swat.addToWishList(SwymPageData, function(e){
                        self.wishlistButton.classList.add('wishlist-button--added');
                    });
                    self.cart.refreshWishlist();
                }
            });
        } else {
            this.wishlistSizes.forEach(function(element) {
                let activeProductId = SwymPageData.empi;
                let activeVariantId = element.dataset.variant;
                self.wishlistButton = self.querySelector('.wishlist-button');
        
                var isInWishlist = products.find(function(p){
                    return p.empi == activeProductId && p.epi == activeVariantId;
                });
                if(isInWishlist){
                    element.classList.add('wishlist-sizes__size--added');
                    self.wishlistButton.classList.add('wishlist-button--added');
                } else if (element.dataset.available === 'true') {
                    element.classList.remove('wishlist-sizes__size--added');
                }
                element.addEventListener('click', () => {
                    SwymPageData.et = 4;	// et 4 stands for wishlist event type
                    SwymPageData.epi = activeVariantId;
                    
                    if (element.classList.contains('wishlist-sizes__size--added')) {
                        _swat.removeFromWishList(SwymPageData, function(e){
                            element.classList.remove('wishlist-sizes__size--added');
                            self.wishlistButton.classList.remove('wishlist-button--added');
                        });
                        let savedCount = 0;
                        self.wishlistSizes.forEach(function(element) {
                            if (element.classList.contains('wishlist-sizes__size--added')) savedCount++;
                        });
                        if (savedCount === 0) {
                            self.wishlistButton.classList.remove('wishlist-button--added');
                        }
                        self.cart.refreshWishlist();
                        return;
                    }
                    _swat.addToWishList(SwymPageData, function(e){
                        element.classList.add('wishlist-sizes__size--added');
                        self.wishlistButton.classList.add('wishlist-button--added');
                    });
                    self.cart.refreshWishlist();
                });
            });
        }
    }

    swymInit() {
  
        if(!window.SwymCallbacks){
         window.SwymCallbacks = [];
        }
        window.SwymCallbacks.push(() => {
            _swat.fetchWrtEventTypeET(this.fetchCallbackFn.bind(this), 4)
        });
    }
}

customElements.define('wishlist-popup', WishlistPopup);


class CartUpsell extends HTMLElement {
    constructor() {
        super();
    }
    
    connectedCallback() {
        if (!this.listener) {
            setTimeout(() => {
                this.listener = true;
                this.container = this.querySelector('.cartupsell__container');
                this.productsContainer = this.querySelector('.cartupsell__products');
                this.addToCartButtons = document.querySelectorAll('.product-form--atc-button');
                this.cart = document.querySelector('cart-wrapper');
                //document.addEventListener('shopify-variants:add-to-cart', this.addToCart.bind(this));
                this.addEventListener('click', this.shouldClose.bind(this));
            });
        }
    }

    shouldClose(e) {
        if (e.target.closest('.cartupsell__product') === null && e.target.closest('.cartupsell__header') === null) {
            this.cart.close();
        }
    }

    async addToCart(e) {
        return;
        this.productsContainer.innerHTML = '';
        this.cart.open();
        let product = e.detail.handle;
        let { recommendations } = await fetch(`/products/${product}?view=upsell`).then(response => response.json());
        if (recommendations.length === 0) return;
        recommendations.map((recommendationProduct) => {
            let isDiscounted = recommendationProduct.compare_at_price > recommendationProduct.price;
            let discountedPercentage = Math.round((recommendationProduct.compare_at_price - recommendationProduct.price) / recommendationProduct.compare_at_price * 100);
            let recommendationProductHtml = `
                <div class="cartupsell__product">
                    <a class="cartupsell__product-image productitem--image-link" href="/products/${recommendationProduct.handle}">
                        <img src="${recommendationProduct.featured_image}" alt="${recommendationProduct.title}" />
                    </a>
                    <div class="cartupsell__product-info">
                        <div class="cartupsell__product-vendor productitem--vendor">${recommendationProduct.vendor}</div>
                        <div class="cartupsell__product-title productitem--title">${recommendationProduct.title}</div>
                        <div class="cartupsell__product-price ${isDiscounted ? 'cartupsell__product-price--discounted' : ''} productitem--price">
                            ${isDiscounted ? `<span class="product--badge badge--sale" data-badge-sales="">
                                Save <span data-price-percent-saved="">${discountedPercentage}</span>%
                            </span>`: ''}
                            ${isDiscounted ? `<span class="cartupsell__product-price cartupsell__product-price--compare">${window.Shopify.formatMoney(recommendationProduct.compare_at_price)}</span>` : ''}
                            <span class="cartupsell__product-price cartupsell__product-price--current">${window.Shopify.formatMoney(recommendationProduct.price)}</span>
                        </div>
                    </div>
                </div>
            `;

            this.productsContainer.innerHTML += recommendationProductHtml;
        });
        this.classList.toggle('cartupsell--open');
    }
}

customElements.define('cart-upsell', CartUpsell);

const listenToCart = (callback) => {
    const ShopifyCartURLs = [
      "add",
      "add.js",
    ];
  
    function isShopifyCartURL(url) {
      if (!url) return false;
      const path = url.split("/").pop().split("?")[0];
      return ShopifyCartURLs.includes(`${path}`);
    }
  
    function dispatchEvent(url, detail) {
      callback(detail)
    }
  
    function fetchOverride() {
      if (!window.fetch || typeof window.fetch !== "function") return;
      const originalFetch = window.fetch;
      window.fetch = function () {
        const response = originalFetch.apply(this, arguments);
        if (isShopifyCartURL(arguments[0])) {
          response.then((res) => {
            res
              .clone()
              .json()
              .then((data) => dispatchEvent(res.url, data));
          });
        }
  
        return response;
      };
    }
  
    function XHROverride() {
      if (!window.XMLHttpRequest) return;
  
      const originalOpen = window.XMLHttpRequest.prototype.open;
      window.XMLHttpRequest.prototype.open = function () {
        const url = arguments[1];
        this.addEventListener("load", function () {
          if (isShopifyCartURL(url)) {
            dispatchEvent(url, this.response);
          }
        });
        return originalOpen.apply(this, arguments);
      };
    }
  
    XHROverride();
    fetchOverride();
};

class Thresholds extends HTMLElement {
    constructor() {
        super();
        setTimeout(() => {
            this.thresholdLabel = this.querySelector('.thresholds__label');
            this.initThresholds();
        }, 1000);
        
    }

    connectedCallback() {
        if (!this.listener) {
            this.listener = true;
            listenToCart(this.initThresholds.bind(this));
        }
    } 

    async initThresholds() {
        let cart = await fetch('/cart.js').then(response => response.json());
        let cartTotal = cart.total_price / 100;

        let thresholds = this.querySelectorAll('.thresholds-progress__item');
        let thresholdLast = thresholds[thresholds.length - 1];
        let max = thresholdLast.dataset.threshold;
        let progress = cartTotal / max * 100;
        let progressElement = this.querySelector('.thresholds-progress');
        progressElement.style.setProperty('--progress', progress + '%');
        let validThresholds = [];
        let closestThreshold = false;
        
        this.checkLocation(thresholds);
        thresholds = this.querySelectorAll('.thresholds-progress__item:not([data-disabled="true"])');

        thresholds.forEach(function(element) {
            let threshold = element.dataset.threshold;
            let distance = threshold / max * 100;
            if (thresholdLast === element) distance = 90;
            element.style.setProperty('--distance', distance + '%');
            
            if (cartTotal >= threshold) {
                validThresholds.push(element);
            } else if (!closestThreshold) {
                closestThreshold = element;
            }
        });
        
        let title = validThresholds.length > 0 ? `Unlocked ${validThresholds.map(el => `<strong>${el.dataset.title}</strong>`).join(' + ')} <br />` : '';
        let remaining = closestThreshold ? closestThreshold.dataset.threshold - cartTotal : 0;
        let remainingTitle = closestThreshold ? `Add <strong>${window.Shopify.formatMoney(remaining * 100)}</strong> to unlock <strong>${closestThreshold.dataset.title}</strong>` : '';
        let description = `${title} ${remainingTitle}`;
        this.thresholdLabel.innerHTML = description;
    }

    async checkLocation(thresholds) {
        let location = getCookie('user_location');
        if (!location) {
            let ipLocation = await fetch('https://ipinfo.io/json?token=40cf7a7b489b17').then(response => response.json());
            location = ipLocation.country;
            setCookie('user_location', location, 365);
        }

        if (location !== 'AU') {
            let freeShipping = false;//thresholds.find((element) => element.dataset.title === 'Free Shipping');
            thresholds.forEach((element) => {
                if (element.dataset.title === 'Free Shipping') {
                    freeShipping = element;
                    element.dataset.disabled = 'true';
                }
            });

            if (freeShipping) {
                freeShipping.style.display = 'none';
            }
            if (thresholds.length === 1) {
                this.style.display = 'none';
            }
        }
    }
}

customElements.define('thresholds-wrapper', Thresholds);


class Cart extends HTMLElement {
    constructor() {
        super();
        this.state = 'cart';
        this.wishlistCountdown = false;
    }

    connectedCallback() {
        if (this.listener)  return;
        this.listener = true;

        setTimeout(() => {
            this.tabs = this.querySelectorAll('.cart-wrapper__title');
            this.productsContainer = this.querySelector('.cart-wrapper__products');
            this.productList = this.querySelector('.cart-wrapper__products-list');
            this.itemCount = this.querySelector('.cart-wrapper__count');
            this.wishlistCount = this.querySelector('.cart-wrapper__count-wishlist');
            this.subtotal = this.querySelector('.cart-wrapper__floating-subtotal-value');
            this.cartButton = document.querySelector('.site-header-cart-button');
            this.overlay = this.querySelector('.cart-wrapper__overlay');
            this.cartClose = this.querySelector('.cart-wrapper__close');
            this.installments = this.querySelector('.cart-wrapper__floating-installments-label');
            this.productFloating = this.querySelector('.cart-wrapper__floating');
            this.productButtons = this.querySelector('.cart-wrapper__buttons');
            this.productUpsellListTitle = this.querySelector('.cart-wrapper__upsell-title');
            this.productUpsellList = this.querySelector('.cart-wrapper__upsell-list');
            this.productsTitles = this.querySelectorAll('.cart-wrapper__products-title:not(.cart-wrapper__products-title--empty)');
            this.cartEmptyTitle = this.querySelector('.cart-wrapper__products-title--empty');
            
            this.productsContainerWishlist = this.querySelector('.cart-wrapper__wishlist .cart-wrapper__products');
            this.wishlistContainer = this.querySelector('.cart-wrapper__wishlist-items');
            this.wishlistSubtotal = this.querySelector('.cart-wrapper__floating-info__wishlist .cart-wrapper__floating-subtotal-value');
            this.wishlistCountdownElement = this.querySelector('.cart-wrapper__wishlist-discount__callout-timer');
            this.wishlistCountdownContainer = this.querySelector('.cart-wrapper__floating-info__discount');
            this.wishlistAddAll = this.querySelector('.cart-wrapper__wishlist-add-all');
            this.installmentsWislist = this.querySelector('.cart-wrapper__wishlist .cart-wrapper__floating-installments-label');
            this.productFloatingWishlist = this.querySelector('.cart-wrapper__wishlist .cart-wrapper__floating');
            this.productButtonsWishlist = this.querySelector('.cart-wrapper__wishlist .cart-wrapper__buttons');
            this.cartUpsell = this.querySelector('cart-upsell');
            this.wishlistHeaderButton = document.querySelector('.site-header-wishlist-button');

            this.desktopUpsellProducts = this.querySelector('.cartupsell__products');

            this.cartCounter = document.querySelector('.site-header-cart--count');
            
            this.tabs.forEach(function(element) {
                element.addEventListener('click', this.tabClick.bind(this, element));
            }.bind(this));
    
            this.cartButton.addEventListener('click', this.open.bind(this));
            this.overlay.addEventListener('click', this.close.bind(this));
            this.cartClose.addEventListener('click', this.close.bind(this));
            this.wishlistAddAll.addEventListener('click', this.addAllToCart.bind(this));
            this.productsContainer.addEventListener('scroll', this.scrollCart.bind(this));
            this.productsContainerWishlist.addEventListener('scroll', this.scrollWishlist.bind(this));
            this.wishlistHeaderButton.addEventListener('click', () => {
                this.setState('wishlist');
                this.open();
            });

            listenToCart(() => {
                this.refreshCart();
                this.refreshWishlist();
                this.open();
            });


            setTimeout(() => {
                this.refreshWishlist();
            }, 1000);
        }, 500);

        this.wishlistCountdown = getCookie('wishlistCountdownStarted');
        if (!!this.wishlistCountdown && this.wishlistCountdown != 'done') {
            this.startCountdown(this.wishlistCountdown);
        }
    }

    removeFromWishList(e) {
        let variantId = e.detail.variantId;
        let self = this;
        _swat.removeFromWishList({epi: variantId, et: 4}, function(e){
            self.refreshWishlist();
        });
    }

    addAllToCart = async () => {
        let wishlistItems = this.wishlistContainer.querySelectorAll('.cart-wrapper__product');
        let wishlistItemsIds = [...wishlistItems].map((element) => ({
            id: element.dataset.epi,
            quantity: 1
        }));

        await fetch(`/cart/add.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: wishlistItemsIds
            })
        }).then(function(response) {
            return response.json();
        });
        if (!!this.wishlistCountdown && this.wishlistCountdown != 'done') {
            let timeNow = new Date();
            let timeDiff = (this.wishlistCountdown - timeNow) / 1000;
            setCookie('discount', 'WISHLIST', false, timeDiff);
        }

        this.refreshCart();

        wishlistItems.forEach((element) => {
            _swat.removeFromWishList({
                et: 4,
                epi: element.dataset.epi
            });
        });

        this.refreshWishlist();
    }

    startCountdown = (countdown = false) => {
        let timeStart = new Date();
        let countdownEnd = new Date(timeStart.getTime() + 10*60000);
        if (countdown) {
            countdownEnd = new Date(countdown);
        } else {
            setCookie('wishlistCountdownStarted', countdownEnd, 100);
        }
        this.wishlistCountdown = countdownEnd;
        this.wishlistCountdownInterval = setInterval(() => {
            let timeNow = new Date();
            let timeDiff = this.wishlistCountdown - timeNow;
            if (timeDiff < 0) {
                clearInterval(this.wishlistCountdownInterval);
                this.wishlistCountdownContainer.classList.add('cart-wrapper__floating-info__discount--hidden');
                setCookie('wishlistCountdownStarted', 'done', 100);
            } else {
                this.wishlistCountdownElement.innerHTML = convertTime(timeDiff);
            }
        }, 500);
    }

    scrollCart = () => {
        let scrollTop = this.productsContainer.scrollTop;
        if (scrollTop > 0) {
            this.productFloating.classList.add('cart-wrapper__floating--scroll');
            this.productButtons.classList.add('cart-wrapper__buttons--scroll');
        } else {
            this.productFloating.classList.remove('cart-wrapper__floating--scroll');
            this.productButtons.classList.remove('cart-wrapper__buttons--scroll');
        }
    }

    scrollWishlist = () => {
        let scrollTop = this.productsContainerWishlist.scrollTop;
        if (scrollTop > 0) {
            this.productFloatingWishlist.classList.add('cart-wrapper__floating--scroll');
            this.productButtonsWishlist.classList.add('cart-wrapper__buttons--scroll');
        } else {
            this.productFloatingWishlist.classList.remove('cart-wrapper__floating--scroll');
            this.productButtonsWishlist.classList.remove('cart-wrapper__buttons--scroll');
        }
    }

    setState = (state) => {
        this.state = state;
        this.dataset.state = state;
        let tab = this.querySelector(`.cart-wrapper__title[data-tab="${state}"]`);
        this.tabs.forEach(function(element) {
            element.classList.remove('cart-wrapper__title--active');
        });
        tab.classList.add('cart-wrapper__title--active');

        if (state === 'wishlist') {
            if (!this.wishlistCountdown) {
                this.startCountdown();
            } else if (this.wishlistCountdown === 'done') {
                this.wishlistCountdownContainer.classList.add('cart-wrapper__floating-info__discount--hidden');
            }
        }
    }

    tabClick = (element) => {
        this.setState(element.dataset.tab);
    }

    open = async (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        await this.refreshCart();
        this.classList.add('cart-wrapper--open');
        document.body.classList.add('bcart-wrapper--open');
        document.documentElement.classList.add('bcart-wrapper--open');
        return false;
    }

    close = () => {
        this.classList.remove('cart-wrapper--open');
        this.cartUpsell.classList.remove('cartupsell--open');
        document.body.classList.remove('bcart-wrapper--open');
        document.documentElement.classList.remove('bcart-wrapper--open');
    }

    refreshWishlist = async () => {
        let self = this;
        if(!window.SwymCallbacks){
            window.SwymCallbacks = [];
        }
        let cart = await fetch('/cart?view=json').then(response => response.json());
        window.SwymCallbacks.push((swat) => {
            swat.fetchWrtEventTypeET(() => {
                swat.fetchLists({
                    callbackFn: async (lists) => {
                        let wishlist = lists[0];
                        let wishlistItems = ((wishlist || {}).listcontents || []);

                        wishlistItems = wishlistItems.filter((item) => {
                            let cartContains = cart.items.find((cartItem) => cartItem.variant_id == item.epi);
                            if (cartContains) {
                                _swat.removeFromWishList({epi: cartContains.item, et: 4});
                            }
                            return !cartContains;
                        });

                        if (wishlistItems.length === 0) {
                            if (this.state === 'wishlist' && !this.productFloatingWishlist.classList.contains('visually-hidden')) {
                                this.setState('cart');
                            }
                            this.productFloatingWishlist.classList.add('visually-hidden');
                            this.productButtonsWishlist.classList.add('visually-hidden');
                            this.productsContainerWishlist.classList.add('visually-hidden');
                            this.wishlistHeaderButton.querySelector('.site-header-wishlist--count').classList.remove('visible');
                        } else {
                            this.productFloatingWishlist.classList.remove('visually-hidden');
                            this.productButtonsWishlist.classList.remove('visually-hidden');
                            this.productsContainerWishlist.classList.remove('visually-hidden');                            
                            this.wishlistHeaderButton.querySelector('.site-header-wishlist--count').classList.add('visible');
                        }
                        
                        this.wishlistHeaderButton.querySelector('.site-header-wishlist--count').dataset.headerWishlistCount = wishlistItems.length;


                        self.wishlistContainer.innerHTML = '';
                        let totalPrice = 0;
                        let totalOriginalPrice = 0;
                        let prices = await Promise.all(wishlistItems.map(async (element) => {
                            let elUrl = element.du.replace('https://www.beactivewear.com.au/', '/');
                            let productData = await fetch(`${elUrl}?view=json`).then(response => response.json());
                            let product = productData.product;
                            let variant = product.variants.find((variant) => variant.id == element.epi);
                            let variantPrice = parseFloat(variant.price * 100);
                            let comparePrice = parseFloat(variant.compare_at_price * 100);
                            let title = product.title;
                            let image = product.featured_image;

                            let sizeOption = product.options.find((option) => option.name === 'Size');
                            let sizeSelectorHTML = '';
                            if (sizeOption) {
                                let sizeOptions = sizeOption.values;
                                sizeSelectorHTML = `
                                    <div class="cart-wrapper__product-size form-field-select-wrapper">
                                        <select class="cart-wrapper__product-size-select form-field-input form-field-select">
                                            ${sizeOptions.map((option) => {
                                                let optionVariant = product.variants.find((variant) => variant.options.includes(option));
                                                return `<option ${!optionVariant.available ? 'disabled' : ''} value="${optionVariant.id}" ${optionVariant.id == variant.id ? 'selected' : ''}>${option}</option>`
                                            }).join('')}
                                        </select>
                                        <span class="cart-wrapper__product-size-label form-field-title">Size:</span> 
                                    </div>
                                `;
                            }

                            self.wishlistContainer.innerHTML += `
                                <div class="cart-wrapper__product" data-product="${element.empi}" data-epi="${element.epi}">
                                    <a class="cart-wrapper__product-image" href="/products/${product.handle}">
                                        <img src="${image.src}" alt="${title}" />
                                    </a>
                                    <div class="cart-wrapper__product-info">
                                        <h4 class="cart-wrapper__product-title">${title}</h4>
                                        <div class="cart-wrapper__product-price">
                                            ${comparePrice > variantPrice ? `<span class="cart-wrapper__product-price cart-wrapper__product-price--original">${window.Shopify.formatMoney(comparePrice)}</span>` : ''}
                                            <span class="cart-wrapper__product-price cart-wrapper__product-price--current">${window.Shopify.formatMoney(variantPrice)}</span>
                                        </div>
                                        <div class="cart-wrapper__product-actions">
                                            ${sizeSelectorHTML}
                                            <div class="cart-wrapper__product-add">
                                                <button class="button-secondary cart-wrapper__product-add-button">Add to cart</button>
                                            </div>
                                        </div>
                                        <button class="cart-wrapper__product-remove button-primary">
                                            <img src="${productData.remove_icon}" alt="Remove" />
                                        </button>
                                    </div>
                                </div>
                            `;          

                            return {
                                variantPrice,
                                comparePrice,
                            }                          
                        }));

                        prices.map((price) => {
                            totalPrice += price.variantPrice;
                            totalOriginalPrice += price.comparePrice ? price.comparePrice : price.variantPrice;
                        });
                        
                        self.wishlistSubtotal.innerHTML = `
                            ${totalPrice < totalOriginalPrice ? `<span class="cart-wrapper__floating-subtotal-value cart-wrapper__floating-subtotal-value--original">${window.Shopify.formatMoney(totalOriginalPrice)}</span>` : ''}
                            <span class="cart-wrapper__floating-subtotal-value cart-wrapper__floating-subtotal-value--current">${window.Shopify.formatMoney(totalPrice)}</span>
                        `;

                        self.wishlistCount.innerHTML = `(${wishlistItems.length})`;
                        self.installmentsWislist.innerHTML = `or 4 interest-free payments of ${window.Shopify.formatMoney(totalPrice / 4)}`;


                        let wishlistSizeSelects = this.wishlistContainer.querySelectorAll('.cart-wrapper__product-size-select');
                        wishlistSizeSelects.forEach(function(element) {
                            element.addEventListener('change', () => {
                                let epi = element.closest('.cart-wrapper__product').dataset.epi;
                                let empi = element.closest('.cart-wrapper__product').dataset.product;
                                let variantId = element.value;
                                _swat.removeFromWishList({epi, et: 4}, function(e){
                                    SwymPageData.et = 4;	// et 4 stands for wishlist event type
                                    SwymPageData.epi = variantId;
                                    SwymPageData.empi = empi;
                                    _swat.addToWishList(SwymPageData, function(e){
                                        self.refreshWishlist();
                                    });
                                });
                            });
                        });

                        let wishlistRemove = self.wishlistContainer.querySelectorAll('.cart-wrapper__product-remove');
                        wishlistRemove.forEach(function(element) {
                            element.addEventListener('click', () => {
                                let epi = element.closest('.cart-wrapper__product').dataset.epi;
                                _swat.removeFromWishList({epi, et: 4}, function(e){
                                    self.refreshWishlist();
                                });
                            });
                        });

                        let wishlistAdd = self.wishlistContainer.querySelectorAll('.cart-wrapper__product-add-button');
                        wishlistAdd.forEach(function(element) {
                            element.addEventListener('click', () => {
                                let epi = element.closest('.cart-wrapper__product').dataset.epi;
                                fetch('/cart/add.js', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({
                                        id: epi,
                                        quantity: 1
                                    })
                                });
                                let discountCookie = getCookie('discount');
                                _swat.removeFromWishList({epi, et: 4}, function(e){
                                    let timeNow = new Date();
                                    let timeDiff = (self.wishlistCountdown - timeNow) / 1000;
                                    if (discountCookie != 'done') setCookie('discount', 'WISHLIST', false, timeDiff);
                                    self.refreshWishlist();
                                    self.refreshCart();
                                });
                            });
                        });
                    }
                });
            }, 4)
        });
    }

    refreshCart = async () => {
        let cart = await fetch('/cart?view=json').then(response => response.json());
        let discountCode = getCookie('discount');
        let discountAmount = 1;
        if (!!discountCode && discountCode === 'WISHLIST') {
            discountAmount = 1 - (parseInt(this.dataset.discount) / 100);

            if (discountAmount <= 0) discountAmount = 1;
        }

        let thresholdItem = document.querySelector('.cart-wrapper__floating thresholds-wrapper .thresholds-progress__item[data-title="10% Off"]');
        if (thresholdItem) {
            let threshold = parseInt(thresholdItem.dataset.threshold) * 100;
            if (cart.items_subtotal_price >= threshold) {
                if (discountAmount == 1) {
                    discountAmount = 0.9;
                }
            }
        }
        let cartItems = cart.items;

        if (cartItems.length == 0) {
            this.productsTitles.forEach(function(element) {
                element.classList.add('visually-hidden');
            });
            this.cartEmptyTitle.classList.remove('visually-hidden');
            this.cartCounter.classList.remove('visible');
            this.productButtons.classList.add('visually-hidden');
        } else {
            this.productsTitles.forEach(function(element) {
                element.classList.remove('visually-hidden');
            });
            this.cartEmptyTitle.classList.add('visually-hidden');   
            this.cartCounter.classList.add('visible');
            this.productButtons.classList.remove('visually-hidden');
        }

        this.cartCounter.dataset.headerCartCount = cart.item_count;

        let cartTotal = window.Shopify.formatMoney(cart.items_subtotal_price * discountAmount );
        let cartOriginalTotal = window.Shopify.formatMoney(cart.original_total_price);

        this.installments.innerHTML = `or 4 interest-free payments of ${window.Shopify.formatMoney(cart.items_subtotal_price / 4)}`;
        let newHtml = '';
        let upsellProducts = [];

        cartItems.map((item, i) => {
            let { product } = item;

            let upsellProduct = upsellProducts.find((prod) => product.handle === prod.handle);
            if (!upsellProduct && (item.recommendations || []).length > 0) {
                upsellProducts.push({
                    ...product,
                    recommendations: item.recommendations
                });
            }
            let sizeOption = item.product_options.find((option) => option.name === 'Size');
            let sizeSelectorHTML = '';
            if (sizeOption) {
                let sizeOptions = sizeOption.values;
                sizeSelectorHTML = `
                    <div class="cart-wrapper__product-size form-field-select-wrapper">
                        <select class="cart-wrapper__product-size-select form-field-input form-field-select">
                            ${sizeOptions.map((option) => {
                                let optionVariant = product.variants.find((variant) => variant.options.includes(option));
                                return `<option ${!optionVariant.available ? 'disabled' : ''} value="${optionVariant.id}" ${optionVariant.id == item.variant_id ? 'selected' : ''}>${option}</option>`
                            }).join('')}
                        </select>
                        <span class="cart-wrapper__product-size-label form-field-title">Size:</span> 
                    </div>
                `;
            }
            newHtml += `
                <div class="cart-wrapper__product" data-index="${i}">
                    <a class="cart-wrapper__product-image" href="/products/${item.product.handle}">
                        <img src="${item.featured_image.url}" alt="${item.title}" />
                    </a>
                    <div class="cart-wrapper__product-info">
                        <a href="/products/${item.product.handle}">
                            <h4 class="cart-wrapper__product-title">${item.title}</h4>
                        </a>
                        <div class="cart-wrapper__product-price">
                            ${item.original_price > item.price * discountAmount ? `<span class="cart-wrapper__product-price cart-wrapper__product-price--original">${window.Shopify.formatMoney(item.original_price)}</span>` : ''}
                            <span class="cart-wrapper__product-price cart-wrapper__product-price--current ${item.original_price > item.price * discountAmount ? 'cart-wrapper__product-price--current-discounted' : ''}">${window.Shopify.formatMoney(item.price * discountAmount)}</span>
                        </div>
                        <div class="cart-wrapper__product-actions">
                            ${sizeSelectorHTML}
                            <div class="cart-wrapper__product-quantity">
                                <button class="button-primary cart-wrapper__product-quantity-minus">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="2" viewBox="0 0 10 2"><path fill="currentColor" fill-rule="evenodd" d="M0 0h10v2H0z"/></svg>
                                </button>
                                <input type="number" class="cart-wrapper__product-quantity-input" min="0" value="${item.quantity}" />
                                <button class="button-primary cart-wrapper__product-quantity-plus">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"><path fill="currentColor" fill-rule="evenodd" d="M10 4H6V0H4v4H0v2h4v4h2V6h4z"/></svg>
                                </button>
                            </div>
                        </div>
                        <button class="cart-wrapper__product-remove button-primary">
                            <img src="${cart.remove_icon}" alt="Remove" />
                        </button>
                    </div>
                </div>
            `;
        });

        let upsellProductsHtml = '';
        let desktopUpsellProductsHtml = '';
        let firstProductMaxRecommendations = 3;

        if (upsellProducts.length >= 3) {
            firstProductMaxRecommendations = 1;
        } else if (upsellProducts.length === 2) {
            firstProductMaxRecommendations = 2;
        }
        let totalAddedProducts = 0;
        let foundRecommendation = false;
        upsellProducts.map((product, prodInd) => {
            let recommendations = product.recommendations;
            let addedProducts = 0;
            recommendations.map((recommendation, i) => {
                if ((prodInd === 0 && addedProducts >= firstProductMaxRecommendations)) return;
                let recommendationProduct = recommendation.data;
                let isInCart = cartItems.find((item) => item.product.handle === recommendationProduct.handle);
                let hasAvailableVariants = recommendation.data.variants.find((variant) => variant.available);
                if (isInCart || !hasAvailableVariants) return;
                addedProducts++;
                totalAddedProducts++;
                foundRecommendation = true;
                let variant = recommendationProduct.variants[0];
                let variantPrice = parseFloat(variant.price * 100);
                let comparePrice = parseFloat(variant.compare_at_price * 100);

                let sizeOption = recommendation.options_with_values.find((option) => option.name === 'Size');
                let sizeSelectorHTML = '';
                if (sizeOption) {
                    let sizeOptions = sizeOption.values;
                    sizeSelectorHTML = `
                        <div class="cart-wrapper__product-size form-field-select-wrapper">
                            <select class="cart-wrapper__product-size-select form-field-input form-field-select">
                                ${sizeOptions.map((option) => {
                                    let optionVariant = recommendationProduct.variants.find((variant) => variant.options.includes(option));
                                    return `<option ${!optionVariant.available ? 'disabled' : ''} value="${optionVariant.id}" ${optionVariant.id == variant.id ? 'selected' : ''}>${option}</option>`
                                }).join('')}
                            </select>
                            <span class="cart-wrapper__product-size-label form-field-title">Size:</span> 
                        </div>
                    `;
                }

                if (totalAddedProducts > 5) return;

                let recommendationProductHtml = `
                    <div class="cart-wrapper__product cart-wrapper__product--upsell" data-epi="${variant.id}">
                        <a class="cart-wrapper__product-image" href="/products/${recommendationProduct.handle}">
                            <img src="${recommendationProduct.featured_image}" alt="${recommendationProduct.title}" />
                        </a>
                        <div class="cart-wrapper__product-info">
                            <a href="/products/${recommendationProduct.handle}">
                                <h4 class="cart-wrapper__product-title">${recommendationProduct.title}</h4>
                            </a>
                            <div class="cart-wrapper__product-price">
                                ${comparePrice > variantPrice ? `<span class="cart-wrapper__product-price cart-wrapper__product-price--original">${window.Shopify.formatMoney(comparePrice / 100)}</span>` : ''}
                                <span class="cart-wrapper__product-price cart-wrapper__product-price--current">${window.Shopify.formatMoney(variantPrice / 100)}</span>
                            </div>
                            <div class="cart-wrapper__product-actions">
                                ${sizeSelectorHTML}
                                <div class="cart-wrapper__product-add">
                                    <button class="button-secondary cart-wrapper__product-add-button">Add to cart</button>
                                </div>
                            </div>
                        </div>
                    </div>
                `;          

                upsellProductsHtml += recommendationProductHtml;

                if (totalAddedProducts > 3) return;
                let isDiscounted = recommendationProduct.compare_at_price > recommendationProduct.price;
                let discountedPercentage = Math.round((recommendationProduct.compare_at_price - recommendationProduct.price) / recommendationProduct.compare_at_price * 100);
                let recommendationDesktopProductHtml = `
                    <div class="cartupsell__product">
                        <a class="cartupsell__product-image productitem--image-link" href="/products/${recommendationProduct.handle}">
                            <img src="${recommendationProduct.featured_image}" alt="${recommendationProduct.title}" />
                        </a>
                        <div class="cartupsell__product-info">
                            <div class="cartupsell__product-vendor productitem--vendor">${recommendationProduct.vendor}</div>
                            <div class="cartupsell__product-title productitem--title">${recommendationProduct.title}</div>
                            <div class="cartupsell__product-price ${isDiscounted ? 'cartupsell__product-price--discounted' : ''} productitem--price">
                                ${isDiscounted ? `<span class="product--badge badge--sale" data-badge-sales="">
                                    Save <span data-price-percent-saved="">${discountedPercentage}</span>%
                                </span>`: ''}
                                ${isDiscounted ? `<span class="cartupsell__product-price cartupsell__product-price--compare">${window.Shopify.formatMoney(recommendationProduct.compare_at_price)}</span>` : ''}
                                <span class="cartupsell__product-price cartupsell__product-price--current">${window.Shopify.formatMoney(recommendationProduct.price)}</span>
                            </div>
                        </div>
                    </div>
                `;

                desktopUpsellProductsHtml += recommendationDesktopProductHtml;
            });
        });

        if (!foundRecommendation) {
            this.productUpsellListTitle.classList.add('visually-hidden');
            this.cartUpsell.classList.remove('cartupsell--open');
        } else {
            this.productUpsellListTitle.classList.remove('visually-hidden');
            this.cartUpsell.classList.add('cartupsell--open');
        }

        this.productList.innerHTML = newHtml;
        this.productUpsellList.innerHTML = upsellProductsHtml;
        this.desktopUpsellProducts.innerHTML = desktopUpsellProductsHtml;

        let productSizeSelects = this.productList.querySelectorAll('.cart-wrapper__product-size-select');
        let productQuantityInputs = this.productList.querySelectorAll('.cart-wrapper__product-quantity-input');
        let productQuantityMinus = this.productList.querySelectorAll('.cart-wrapper__product-quantity-minus');
        let productQuantityPlus = this.productList.querySelectorAll('.cart-wrapper__product-quantity-plus');
        let productRemove = this.productList.querySelectorAll('.cart-wrapper__product-remove');
        let self = this;
        productSizeSelects.forEach(function(element) {
            element.addEventListener('change', self.productSizeChange.bind(self));
        });

        productQuantityInputs.forEach(function(element) {
            element.addEventListener('change', self.productQuantityChange.bind(self));
        });

        productQuantityMinus.forEach(function(element) {
            element.addEventListener('click', self.productQuantityMinus.bind(self));
        });

        productQuantityPlus.forEach(function(element) {
            element.addEventListener('click', self.productQuantityPlus.bind(self));
        });

        productRemove.forEach(function(element) {
            element.addEventListener('click', self.productRemove.bind(self));
        });


        let wishlistAdd = this.productUpsellList.querySelectorAll('.cart-wrapper__product-add-button');
        wishlistAdd.forEach(function(element) {
            element.addEventListener('click', () => {
                let variantId = element.closest('.cart-wrapper__product').querySelector('.cart-wrapper__product-size-select').value;
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: 1
                    })
                });
                self.refreshWishlist();
                self.refreshCart();
            });
        });

        this.itemCount.innerHTML = `(${cart.item_count})`;
        this.subtotal.innerHTML = `
            ${cartTotal < cartOriginalTotal ? `<span class="cart-wrapper__floating-subtotal-value cart-wrapper__floating-subtotal-value--original">${cartOriginalTotal}</span>` : ''}
            <span class="cart-wrapper__floating-subtotal-value cart-wrapper__floating-subtotal-value--current">${cartTotal}</span>
        `;
        let checkoutButton = this.querySelector('.cart-wrapper__button-checkout');
        let discountParam = '';
        if (discountAmount < 1 && !!discountCode) {
            discountParam = `?discount=${discountCode}`;
        } 
    
        checkoutButton.href = `/checkout${discountParam}`;
    }

    updateThresholds = async () => {
        let thresholds = document.querySelectorAll('thresholds-wrapper');
        thresholds.forEach(function(element) {
            element.initThresholds();
        });
    }

    productSizeChange = async (e) => {
        let variant = e.target.value;
        let index = Array.from(this.querySelectorAll('.cart-wrapper__product-size-select')).indexOf(e.target);
        let cart = await fetch('/cart.js').then(response => response.json());
        let item = cart.items[index];
        await fetch(`/cart/change.js?quantity=0&id=${item.id}`).then(function(response) {
            return response.json();
        });
        await fetch(`/cart/add.js?quantity=${item.quantity}&id=${variant}`).then(function(response) {
            return response.json();
        });
        await this.refreshCart();
        await this.updateThresholds();
    }

    productQuantityChange = async (e) => {
        let quantity = e.target.value;
        let index = Array.from(this.querySelectorAll('.cart-wrapper__product-quantity-input')).indexOf(e.target);
        let cart = await fetch('/cart.js').then(response => response.json());
        let item = cart.items[index];
        await fetch(`/cart/change.js?quantity=${quantity}&id=${item.id}`).then(function(response) {
            return response.json();
        });
        await this.refreshCart();
        await this.updateThresholds();
    }

    productQuantityMinus = async (e) => {
        let index = Array.from(this.querySelectorAll('.cart-wrapper__product-quantity-minus')).indexOf(e.target);
        let cart = await fetch('/cart.js').then(response => response.json());
        let item = cart.items[index];
        let quantity = item.quantity - 1;
        await fetch(`/cart/change.js?quantity=${quantity}&id=${item.id}`).then(function(response) {
            return response.json();
        });
        await this.refreshCart();
        await this.updateThresholds();
    }

    productQuantityPlus = async (e) => {
        let index = Array.from(this.querySelectorAll('.cart-wrapper__product-quantity-plus')).indexOf(e.target);
        let cart = await fetch('/cart.js').then(response => response.json());
        let item = cart.items[index];
        let quantity = item.quantity + 1;
        await fetch(`/cart/change.js?quantity=${quantity}&id=${item.id}`).then(function(response) {
            return response.json();
        });
        await this.refreshCart();
        await this.updateThresholds();
    }

    productRemove = async (e) => {
        let index = e.target.closest('.cart-wrapper__product').dataset.index;
        let cart = await fetch('/cart.js').then(response => response.json());
        let item = cart.items[index];
        await fetch(`/cart/change.js?quantity=0&id=${item.id}`).then(function(response) {
            return response.json();
        });
        await this.refreshCart();
        await this.updateThresholds();
    }

}

customElements.define('cart-wrapper', Cart);